<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="top-center"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'DyehouseDailyMetric.title' | translateWF: 'Daily Consumptions Import' }}</h1>
        <div class="page__title_buttons"></div>
      </div>
    </div>

    <p-panel [header]="'DyehouseDailyMetric.subtitle' | translateWF: 'Bulk Import Daily Consumptions'">
      <ng-template pTemplate="icons">
        <p-button
          [label]="'DyehouseDailyMetric.submit' | translateWF: 'Import'"
          icon="pi pi-upload"
          (onClick)="onSubmit()"
          [outlined]="true"
          [disabled]="form.invalid || isLoading() > 0"
        />
      </ng-template>

      <p-card>
        <form [formGroup]="form">
          <!-- File upload -->
          <div class="form-box">
            <label for="fileInput">{{ 'DyehouseDailyMetric.file_label' | translateWF: 'Excel file (.xlsx)' }} *</label>
            <input
              #fileInput
              id="fileInput"
              type="file"
              accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              (change)="onFileSelected($event)"
              class="file-input"
            />
            <small class="p-error" *ngIf="file.invalid && file.touched">
              {{ 'DyehouseDailyMetric.file_required' | translateWF: 'File is required' }}
            </small>
          </div>
        </form>
      </p-card>

      <ng-template pTemplate="footer">
        <div class="row-between-center">
          <p-message severity="secondary" variant="simple">
            {{
              'DyehouseDailyMetric.description'
                | translateWF
                  : 'Select an .xlsx file, then click Import to preview
            before saving.'
            }}
          </p-message>
          <p-button class="sample-link" (click)="downloadTemplate()" variant="outlined" size="small">
            <i class="pi pi-download"></i>
            {{ 'DyehouseDailyMetric.download_template' | translateWF: 'Download Template' }}
          </p-button>
        </div>
      </ng-template>
    </p-panel>

    <p-panel [header]="'DyehouseDailyMetric.last_records_title' | translateWF: 'Last Imported Records'">
      <div class="col-xs">
        <!-- Filter panel -->
        <p-panel header=" Filter" data-tone="surface">
          <ng-template pTemplate="icons">
            <p-button
              [label]="'DyehouseDailyMetric.filter_reset' | translateWF: 'Reset'"
              variant="outlined"
              severity="secondary"
              icon="pi pi-times"
              size="small"
              (onClick)="onResetFilter()"
            />
            <p-button [label]="'DyehouseDailyMetric.filter_apply' | translateWF: 'Apply Filter'" icon="pi pi-search" size="small" (onClick)="onApplyFilter()" />
          </ng-template>
          <p-card>
            <div class="grid-auto-4">
              <div class="form-box">
                <label>{{ 'DyehouseDailyMetric.filter_year_label' | translateWF: 'Year' }}</label>
                <p-select
                  class="w-full"
                  [formControl]="filterYear"
                  [options]="yearOptions"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="'DyehouseDailyMetric.filter_year_label' | translateWF: 'Year'"
                  appendTo="body"
                  fluid
                />
              </div>
              <div class="form-box">
                <label>{{ 'DyehouseDailyMetric.filter_month_label' | translateWF: 'Month' }}</label>
                <p-select
                  class="w-full"
                  [formControl]="filterMonth"
                  [options]="monthOptions"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="'DyehouseDailyMetric.filter_month_label' | translateWF: 'Month'"
                  appendTo="body"
                  fluid
                />
              </div>
            </div>
          </p-card>
        </p-panel>

        <p-card data-variant="compact">
          @if (lastRecords().length > 0) {
            <p-table [value]="lastRecords()" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'DyehouseDailyMetric.col_date' | translateWF: 'Date' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_week' | translateWF: 'Week' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_production_kg' | translateWF: 'Production (kg)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_park_energy' | translateWF: 'Park Energy (T)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_natural_gas' | translateWF: 'Natural Gas (T)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_bunker_dyeing' | translateWF: 'Bunker Dyeing (gal)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_bunker_finishing' | translateWF: 'Bunker Finishing (gal)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_water_agua' | translateWF: 'Water Agua (m³)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_water_inoptsa' | translateWF: 'Water Inoptsa (m³)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_energy' | translateWF: 'Energy (kWh)' }}</th>
                  <th>{{ 'DyehouseDailyMetric.col_created_by' | translateWF: 'Created By' }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.date | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.week }}</td>
                  <td>{{ row.productionKg | number: '1.2-2' }}</td>
                  <td>{{ row.parkEnergyTons | number: '1.2-2' }}</td>
                  <td>{{ row.naturalGasTons | number: '1.2-2' }}</td>
                  <td>{{ row.bunkerGalDyeing | number: '1.2-2' }}</td>
                  <td>{{ row.bunkerGalFinishing | number: '1.2-2' }}</td>
                  <td>{{ row.waterAguaM3 | number: '1.2-2' }}</td>
                  <td>{{ row.waterInoptsaM3 | number: '1.2-2' }}</td>
                  <td>{{ row.energyKwh | number: '1.2-2' }}</td>
                  <td>{{ row.createdBy }}</td>
                </tr>
              </ng-template>
            </p-table>
          } @else {
            <p class="empty-state">
              {{ 'DyehouseDailyMetric.no_records' | translateWF: 'No records found for the selected period.' }}
            </p>
          }
        </p-card>
      </div>
    </p-panel>
  </div>
</main>
